import Vue from 'vue'
import _ from  'lodash'
import Bus, { Events } from './bus';

let Instance

export function modalFactory<T>(modal):Function {
	return function getMessageInstance(options:T) {
		const _props = options || {}
		Instance = new Vue({
			render(h) {
				return h(modal, {
					props: _props,
					on: {
						close: () => {
							this.remove()
						}
					}
				})
			},
			methods: {
				remove() {
					setTimeout(() => {
						this.destroy()
					}, 300)
				},
				destroy() {
					this.$destroy()
					document.body.removeChild(this.$el)
					Instance = null
				}
			}
		})
		const component = Instance.$mount()
		document.body.appendChild(component.$el)
		const message:any = Instance.$children[0]
		message.visible = true
		return {
			component: message
		}
	}
}
export function modalRemove() {
	if(Instance) {
		Instance.remove()
	}
}

Vue.prototype.$gridList = new Set()

window.onresize = _.debounce(() => {
    Bus.$emit(Events.Resize)
	Vue.prototype.$gridList.forEach((grid)=>{
		grid.api.sizeColumnsToFit()
	})
}, 400)

Vue.prototype.$confirm = function(title: string, subTitle: string) {
	return new Promise((resolve, reject) => {
		// 提示框
		this.$Modal.confirm({
			title: title,
			content: subTitle,
			onCancel: () => {
				resolve(false)
			},
			onOk: () => {
				resolve(true)
			}
		})
	})
}

Vue.prototype.$validate = function (formStr: string) {
	return new Promise((resolve)=>{
		this.$refs[formStr].validate((valid)=>{
			resolve(valid)
		})
	})
}
